import { type FC } from "react";

import { Button } from "@/shared/components/ui/button";

interface ReconnectBannerProps {
  onReconnect: () => void;
}

export const ReconnectBanner: FC<ReconnectBannerProps> = ({ onReconnect }) => {
  return (
    <div className="flex w-full sm:w-[400px] items-center justify-between rounded-lg border border-red-200 bg-red-50 p-4">
      <p className="text-sm text-primary">Your bank needs you to sign in again</p>
      <Button variant="brand" size="sm" onClick={onReconnect}>
        Reconnect
      </Button>
    </div>
  );
};
